module.exports = __webpack_public_path__ + "static/media/5.232a2ebd.svg";